import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";

export default function ProtectedRoute({ rol, children }) {
  const auth = useAuthStore((s) => ({ token: s.token, rol: s.rol }));

  if (!auth.token) return <Navigate to="/login" replace />;
  if (rol && auth.rol !== rol) {
    // Usuario logueado pero con rol distinto → redirige a su home
    const home = auth.rol === "superadmin" ? "/superadmin/dashboard" : "/local/stream";
    return <Navigate to={home} replace />;
  }
  return children;
}
